import Layout from '@/Layout';
import Router from "next/router";
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setSmarticoLoginContinue } from "../../../store/thunk/gameThunk";
import { gameActions } from '../../../store/gameSlice';

export const smarticoDeepLink = "/cn/rewards-centre";
function index() {
  const [isLogin, setIsLogin] = useState(false);
  const [memberInfo, setMemberInfo] = useState(null);
  const dispatch = useDispatch();
  const boxexData = [
    {
      iconSrc: "/cn/img/otherPageBanner/coins.svg",
      desc: "实时查看最新乐币数量，轻松掌握余额"
    },{
      iconSrc: "/cn/img/otherPageBanner/newDesign.svg",
      desc: "全新界面设计，适配含手机端所有平台"
    },{
      iconSrc: "/cn/img/otherPageBanner/newCart.svg",
      desc: "焕然一新的商店界面，提供更愉悦的购物体验"
    },{
      iconSrc: "/cn/img/otherPageBanner/newPurchase.svg",
      desc: "清晰即时的商品陈列，浏览过程更顺畅"
    },{
      iconSrc: "/cn/img/otherPageBanner/newGames.svg",
      desc: "部分活动与小游戏，也将开放会员兑换游戏次数喽"
    },
  ]

  useEffect(() => {
    global.Pushgtagpiwikurl &&
    global.Pushgtagpiwikurl(
        "rewards-store",
        "Rewards Store",
    );}, []);

    useEffect(() => {
        const localMemberInfo = localStorage.getItem("memberInfo");
        if (localMemberInfo) {
          const parsedInfo = JSON.parse(localMemberInfo);
          setMemberInfo(parsedInfo);
          if (parsedInfo?.memberCode) {
            setIsLogin(true);
          }
        }
      }, []);
    
  const Bonx = ({iconSrc, desc}) => {
    return (
      <div style={{display: "flex", flexDirection:"column", alignItems:"center", marginBottom: "20px"}}>
        <img src={iconSrc} alt="icon" style={{width: "50px", height: "50px"}}/>
        <p style={{marginLeft: "10px", marginTop:"8px"}}>{desc}</p>
      </div>
    )
  }

  return (
      <Layout status={1}>
          <div
              style={{
                  width: "100%",
                  minHeight: "1117px",
              }}
          >
              <div>
                  <img
                      src="/cn/img/otherPageBanner/CN_rewardbanner_desktop.jpg"
                      alt="smarticoEntry"
                      style={{ width: "100%" }}
                  />
              </div>
              <div
                  style={{
                      width: "100%",
                      textAlign: "center",
                  }}
              >
                  <div
                      style={{
                          width: "100%",
                      }}
                  >
                      <p
                          style={{
                              fontWeight: 600,
                              fontSize: "28px",
                              color: "#222222",
                              marginTop: "40px",
                          }}
                      >
                          天王俱乐部搬家到彩金殿堂喽！
                      </p>
                      <p
                          style={{
                              fontWeight: 400,
                              fontSize: "20px",
                              color: "#666666",
                              marginTop: "20px",
                          }}
                      >
                          全新天王俱乐部搬家到彩金殿堂喽!
                          在乐天堂能享受更流畅、更丰厚的兑换体验！
                      </p>
                  </div>
                  <div
                      style={{
                          width: "100%",
                      }}
                  >
                      <p
                          style={{
                              fontWeight: 600,
                              fontSize: "24px",
                              color: "#222222",
                              marginTop: "40px",
                          }}
                      >
                          全新升级，等您体验！
                      </p>
                      <div
                          style={{
                              width: "100%",
                              display: "flex",
                              flexWrap: "wrap",
                              justifyContent: "center",
                              marginTop: "28px",
                          }}
                      >
                          {boxexData.map((item, index) => {
                              return (
                                  <div
                                      key={index}
                                      style={{
                                          width: "208px",
                                          padding: "10px",
                                      }}
                                  >
                                      <Bonx
                                          iconSrc={item.iconSrc}
                                          desc={item.desc}
                                      />
                                  </div>
                              );
                          })}
                      </div>
                  </div>
                  <div
                      style={{
                          width: "100%",
                          marginTop: "60px",
                      }}
                  >
                      <h3>畅玩乐天堂赚取乐币，额外奖励更多精彩！</h3>
                      <h3>立即探索全新 乐币商店商城，解锁丰厚奖励!</h3>
                  </div>
                  <div>
                      <img
                          onClick={() =>{
                            if(!isLogin) {
                              dispatch(setSmarticoLoginContinue(true));
                              dispatch(gameActions.smarticoLoginContinueWithDeepLink(true))
                              global.goUserSign("1");
                              return
                            }
                            Pushgtagdata(
                                "RewardsStore",
                                "Go to Rewards Centre",
                                "RewardsStore_C_Exchange",
                            );
                            Router.push(smarticoDeepLink);
                          }
                          }
                          src="/cn/img/otherPageBanner/Button.png"
                          alt="smarticoEntry"
                          style={{
                              width: "278px",
                              height: "56%",
                              cursor: "pointer",
                              marginTop: "52px",
                          }}
                      />
                  </div>
                  <div
                  style={{
                    marginTop: "52px",
                  }}
                  >
                      想了解更多？前往{" "}
                      <span
                          style={{
                              color: "#00A6FF",
                              cursor: "pointer",
                              textDecoration: "underline",
                          }}
                          onClick={() =>{
                            Pushgtagdata(
                                "RewardsStore",
                                "GO to Help Center",
                                "RewardsStore_C_HelpCenter",
                            );
                            window.open('/cn/CustomerService')
                            }
                          }
                      >
                          帮助中心
                      </span>
                  </div>
              </div>
          </div>
      </Layout>
  );
}

export default index